__turbopack_context__.v({
  "loading": "default-module-scss-module__Rwo_3q__loading",
  "loading__box": "default-module-scss-module__Rwo_3q__loading__box",
  "loading__loader": "default-module-scss-module__Rwo_3q__loading__loader",
});
